import React, { Component } from 'react';

import { HeatMap, Marker } from 'google-maps-react';

import blueDotIcon from '../../../images/blueDot.svg';

const gradient = [
    'rgba(0, 255, 255, 0)',
    'rgba(0, 255, 255, 1)',
    'rgba(0, 191, 255, 1)',
    'rgba(0, 127, 255, 1)',
    'rgba(0, 63, 255, 1)',
    'rgba(0, 0, 255, 1)',
    'rgba(0, 0, 223, 1)',
    'rgba(0, 0, 191, 1)',
    'rgba(0, 0, 159, 1)',
    'rgba(0, 0, 127, 1)',
    'rgba(63, 0, 91, 1)',
    'rgba(127, 0, 63, 1)',
    'rgba(191, 0, 31, 1)',
    'rgba(255, 0, 0, 1)'
]

class ThunderStrikesMap extends Component {

    componentDidMount() {
        this.loadThunderStrikesMap();
    }

    shouldComponentUpdate(nextProps) {

        if (this.props.positions.length !== nextProps.positions.length
            || this.props.showOutageLayer !== nextProps.showOutageLayer
            || this.props.showThunderStormEffects !== nextProps.showThunderStormEffects
            || this.props.showAllThunderHits !== nextProps.showAllThunderHits
            || this.props.showThunderMap !== nextProps.showThunderMap) 
        {
            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate = () => {
        this.loadThunderStrikesMap();
    }

    loadThunderStrikesMap = () => {
        let result;
        
        if (this.props.showOutageLayer && this.props.showThunderStormEffects && this.props.showAllThunderHits){
            if(this.props.showThunderMap){
                result = <HeatMap
                    gradient={gradient}
                    positions={this.props.positions}
                    opacity={0.5}
                    radius={10}
                    dissipating={true}
                    key={Math.random()}
                />
            }
            else {
                result = this.props.positions.map((thunderStrike, index) => (
                    <Marker
                        options={{ icon: {url: blueDotIcon, scaledSize: {width: 20, height: 20}} }}
                        key={index}
                        position={thunderStrike}
                    />  
                ))
            }
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, result);
        //this.props.getThunderStrikesMap(result)
    }

    render() {
        return null
    }
}


export default ThunderStrikesMap;